<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.isLeapYear.fromTimezone" title="From Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.isLeapYear.fromFormat" title="From Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.isLeapYear.fromLocale" title="From Locale" />
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateIsLeapYear.vue");
export default {
    name: "DateIsLeapYear",
    components: { TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.isLeapYear",
            inputs: [""],
            isLeapYear: {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en"
            }
        };
        if (!clone.isLeapYear) {
            clone.isLeapYear = {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en"
            };
        }
        return {
            clone
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section,
        .locale-picker-section,
        .timezone-picker-section {
            width: 100%;
        }
    }
}
</style> 